import type { SdkContext, ISdkPlugin, ISdkPluginClass } from "@/interface/sdk";

export abstract class SdkPlugin implements ISdkPlugin {
  static pluginName: string;
  static requires?: ISdkPluginClass[];

  // 实例方法
  abstract init(context: SdkContext): void | Promise<void>;
  userEnd?(context: SdkContext): void | Promise<void>;
}
